export const indicatorSizes = {
  3: { iconSize: "w-3 h-3", messageSize: "text-base" },
  4: { iconSize: "w-4 h-4", messageSize: "text-base" },
  5: { iconSize: "w-5 h-5", messageSize: "text-lg" },
  6: { iconSize: "w-6 h-6", messageSize: "text-lg" },
  7: { iconSize: "w-7 h-7", messageSize: "text-xl" },
  8: { iconSize: "w-8 h-8", messageSize: "text-xl" },
} as const;

export type IndicatorSize = keyof typeof indicatorSizes;

export interface IndicatorProps {
  indicatorSize: IndicatorSize;
  message: string;
}
